import * as React from "react"
const RunIcon = (props) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={24}
        height={25}
        fill="none"
        {...props}
    >
        <path
            fill="#111"
            d="M20.905 13.478H23l-3.143-4.235-3.143 4.235h2.096c0 3.505-2.819 6.353-6.286 6.353a6.1 6.1 0 0 1-2.934-.74l-1.529 1.545a8.244 8.244 0 0 0 4.463 1.313c4.63 0 8.38-3.79 8.38-8.47ZM5.19 12.42c0-3.505 2.819-6.353 6.286-6.353 1.058 0 2.064.264 2.933.74l1.53-1.545a8.244 8.244 0 0 0-4.463-1.313c-4.63 0-8.38 3.79-8.38 8.47H1l3.143 4.236 3.143-4.235H5.19Z"
        />
        <path
            fill="#111"
            d="M10 15.449a1 1 0 0 0 1.6.8l3.333-2.5a1 1 0 0 0 0-1.6l-3.333-2.5a1 1 0 0 0-1.6.8v5Z"
        />
    </svg>
)
export default RunIcon
